export function formatCurrency(
  value: string | number | null | undefined,
): string {
  if (value === null || value === undefined || value === "") {
    return "R$ 0,00";
  }

  let numberValue: number;

  if (typeof value === "string") {
    // 1) remover prefixo "R$" e espaços
    const clean = value.trim().replace(/^[Rr]\$\s?/, "");

    let normalized: string;
    const hasComma = clean.includes(",");
    const hasDot = clean.includes(".");

    if (hasComma && hasDot) {
      // Formato BR: "1.234,56" → tira todos os pontos de milhar e troca vírgula por ponto
      normalized = clean.replace(/\./g, "").replace(",", ".");
    } else if (!hasComma && hasDot) {
      // Formato US/JS: "1200.00" → mantem o ponto como decimal
      normalized = clean;
    } else if (hasComma && !hasDot) {
      // Apenas vírgula (decimal BR sem milhares): "1200,00" → trocar vírgula por ponto
      normalized = clean.replace(",", ".");
    } else {
      // Nenhum separador: número inteiro, ex.: "1200" → usa tal qual
      normalized = clean;
    }

    numberValue = parseFloat(normalized);
    if (isNaN(numberValue)) {
      return "N/A";
    }
  } else {
    numberValue = value;
    if (isNaN(numberValue)) {
      return "N/A";
    }
  }

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(numberValue);
}
